export default {
  twinRow1: '杰为数字孪生功能可以对物理资源、物理设备和完整生产线进行实时建模与监控。基于本地云环境和实时数字化链，利用杰为平台构建的数字孪生成为一个全透明化的智能制造模型，该模型将数字流程与数字生产线引擎及数字质量相结合，模拟相关性能，自动贡献关于生产计划、执行、质量和交付的优质决策。'
}
